import React, { Fragment } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Header from '../../../components/header';
import Head from '../../../components/head';
import Footer from '../../../components/footer';
import ListaLicitacoesExpo25 from '../../../components/licitacao/listar/expomacuco';


function ListaLicitacoesExpo25Screen() {
    return (
        <Fragment>
            <Head titulo="Licitações realizadas para a Expo Macuco 2025" />
            <Header />
            <Container>
                <ListaLicitacoesExpo25 />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ListaLicitacoesExpo25Screen;